import { useGetMyChannels } from "@/hooks/useIntegration";
import AccountConnections from "./AccountConnections";

const Integration = () => {
  const { data: myChannels } = useGetMyChannels();
  return <AccountConnections myChannels={myChannels} />;
};

export default Integration;
